import { Card, Col, DatePicker, Row } from "antd";
import React, { useEffect, useState } from "react";
// import HeadDashboard from "../../../component/card/Head-Dashboard";
import Logo from "../../../asset/image/image-Dashboard.png";
// import PlantOverviewCard from "../../../component/card/Plant-Overview-Card";
// import ClientOverviewCard from "../../../component/card/Client-Overview-Card";
// import TaskCard from "../../../component/card/Task-Card";
import CONSTANTS from "../../../util/constant/CONSTANTS";
import useHttp from "../../../hooks/use-http";
import dayjs from "dayjs";
const Dashboard = () => {
  const [analytics, setAnalytics] = useState({})
  const [selectedDates, setSelectedDates] = useState({
    startDate: null,
    endDate: null,
  })
  const API = useHttp();
  const { RangePicker } = DatePicker;

  useEffect(() => {
    const ANALYTICS_API = { ...CONSTANTS.API.Analytics.getAll }

    if ((selectedDates?.startDate !== null && selectedDates?.endDate !== null)) {
      ANALYTICS_API.endpoint = `${ANALYTICS_API.endpoint}?startDate=${selectedDates?.startDate}&endDate=${selectedDates?.endDate}`
    }

    API.sendRequest(ANALYTICS_API, (res) => {
      setAnalytics(res?.data)
    })
  }, [selectedDates])

  return (
    <>
      <div className="">
        <div className="my-5">
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Card>
                <p className="font-medium text-lg pb-5">Date Range</p>
                <RangePicker
                  className="w-3/4"
                  onChange={(e) => {
                    // console.log(e);
                    if (e) {
                      setSelectedDates({
                        startDate: dayjs(e[0])?.format("YYYY-MM-DD"),
                        endDate: dayjs(e[1])?.format("YYYY-MM-DD"),
                      });
                    }
                    else {
                      setSelectedDates({
                        startDate: null,
                        endDate: null,
                      });
                    }
                  }}
                />
              </Card>
            </Col>
          </Row>
        </div>

        <Row gutter={[16, 16]}>
          <Col span={8} xs={24} sm={12} md={8} lg={8} xl={8} >
            <Card className="p-5">
              <div>
                <p className="font-semibold text-base text-slate-400">Total User</p>
                <p className="pt-2 font-medium text-xl ">{analytics?.user}</p>
              </div>
            </Card>
          </Col>
          <Col span={8} xs={24} sm={12} md={8} lg={8} xl={8} >
            <Card className="p-5">
              <div>
                <p className="font-semibold text-base text-slate-400">Total Device</p>
                <p className="pt-2 font-medium text-xl ">{analytics?.totalDevice}</p>
              </div>
            </Card>
          </Col>
          <Col span={8} xs={24} sm={12} md={8} lg={8} xl={8} >
            <Card className="p-5">
              <div>
                <p className="font-semibold text-base text-slate-400">Total Active Device</p>
                <p className="pt-2 font-medium text-xl ">{analytics?.activeDevice}</p>
              </div>
            </Card>
          </Col>
          <Col span={8} xs={24} sm={12} md={8} lg={8} xl={8}  >
            <Card className="p-5">
              <div>
                <p className="font-semibold text-base text-slate-400">Total Pets</p>
                <p className="pt-2 font-medium text-xl ">{analytics?.totalPets}</p>
              </div>
            </Card>
          </Col>

        </Row>
      </div>
    </>

  );
};

export default Dashboard;
